import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=31832fe6&scoped=true"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"
import style0 from "./ErrorPage.vue?vue&type=style&index=0&id=31832fe6&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31832fe6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/vercel/path0/components/page/Header.vue').default,Heading: require('/vercel/path0/components/elements/Heading.vue').default,Back: require('/vercel/path0/components/elements/Back.vue').default,PageFooter: require('/vercel/path0/components/page/Footer.vue').default})
